<template>
  <div class="chuKuZuoyeWarp">
    <div class="searchBox" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="inpBox box">
          <el-form-item label="创建时间:" class="item2">
            <el-date-picker
              v-model="createTimes"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="状态:" >
            <el-select v-model="searchFrom.status" placeholder="请选择">
              <el-option label="全部" value="" ></el-option>
              <el-option label="处理中" value="0" ></el-option>
              <el-option label="已处理" value="1" ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="">
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tabref" class="elTab" highlight-current-row border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}" @selection-change='selectGoods'>
        <!-- <el-table-column type="selection" width="50" fixed></el-table-column> -->
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
        <el-table-column prop="riskControlNo" label="风控单据号" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="detilsFn(scope.row)">{{scope.row.riskControlNo}}</el-button>
          </template>
        </el-table-column>
        <el-table-column property="" width="100" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.wayNumber==scope.row.wayNumberYcl"  style="color: #67C23A;">已处理</span>
            <span v-else style="color: #E6A23C;">处理中</span>
          </template>
        </el-table-column>
        <el-table-column prop="wayNumber" label="运单数量" width="120"> </el-table-column>
        <el-table-column prop="wayNumberClz" label="处理中单数" width="120"> </el-table-column>
        <el-table-column prop="wayNumberYcl" label="已处理单数" width="120"> </el-table-column>
        <!-- <el-table-column prop="wayNumberClsb" label="处理失败单数" width="120"> </el-table-column> -->
        <el-table-column property="" width="120" label="处理失败单数">
          <template slot-scope="scope">
            <span v-if="scope.row.wayNumberClsb>0"  style="color: red;">{{scope.row.wayNumberClsb}}</span>
            <span v-else>{{scope.row.wayNumberClsb}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createSubdepartmentName" label="创建部门" min-width="120"> </el-table-column>
        <el-table-column prop="createUser" label="创建人" min-width="120"> </el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
     <el-dialog title="运单明细" :visible.sync="detilsMark" :close-on-click-modal="false" width="80%" center >
      <!--表格1-->
      <div class="chuKuZuoyeWarp-body-table">
        <el-table :data="yundanList" ref="tabref" class="elTab" highlight-current-row  border size="mini" style="width:100%"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
          <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" v-if="scope.row.riskControlState == '3'"  @click="chehuiFN(scope.row)">撤回</el-button>
                <span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
          <el-table-column prop="" label="付款风控反馈" width="120" >
            <template scope="scope">
              <div>
                <span class="" style="color:#409EFF" v-show="scope.row.riskControlState == '0'">待推送</span>
                <span style="color:#E6A23C" v-show="scope.row.riskControlState == '1'">处理中</span>
                <span style="color:#67C23A" v-show="scope.row.riskControlState == '2'">已处理</span>
                <span style="color:#F56C6C" v-show="scope.row.riskControlState == '3'">处理失败</span>
                <span  v-show="scope.row.riskControlState == '4'">不推送</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payer" label="收款方" width="220" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" width="120">
          </el-table-column>
          <el-table-column prop="liquidatedAmountName" label="结算量" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightPricingTypeName" label="运费计价" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="" label="运费单价" width="130">
            <template scope="scope">
              <div>
                <span v-if="scope.row.freightPricingType == '0'">{{scope.row.freightUnitPrice}}元/吨</span>
                <span v-if="scope.row.freightPricingType == '1'">
                  <span v-if="scope.row.freightUnitPrice != 0">{{scope.row.freightUnitPrice}}元/车</span>
                  <span v-else>-</span>
                </span>
                <span v-if="scope.row.freightPricingType == '2'">{{scope.row.freightUnitPrice}}元/方</span>
                <span v-if="scope.row.freightPricingType == '3'">{{scope.row.freightUnitPrice}}元/件</span>
                <span v-if="scope.row.freightPricingType == '' || scope.row.freightPricingType == null">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="freightAmount" label="运费金额(元)" width="140"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="disburseSurcharge" label="支出附加费(元)" width="140"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightAmountTotal" label="运费总额(元)" width="130"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="serviceRate" label="服务费率(%)" width="130"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="serviceCharge" label="服务费(元)" width="140"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="freightTaxTotal" label="支出总额(元)" width="140"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfPaymentAmount" label="已付款金额(元)" width="150"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfNoPaymentAmount" label="未付款金额(元)" width="150"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfInvoiceAmount" label="已开票金额(元)" width="150"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfNoInvoiceAmount" label="未开票金额(元)" width="150"
          :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="generalCarrier" label="承运方" width="220" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="plateNumber" label="车牌号" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverPhone" label="司机电话" width="130" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="orderNo" label="订单号" width="230" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="yfInvoiceOn" label="发票号" width="200" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
          <el-table-column prop="onlineMessage" label="风控异常反馈" :show-overflow-tooltip="true" width="220" :formatter="formatterRowEmpty">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detilsMark=false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findRiskControlInfoList, findWayBusinessList, removeRiskControlInfo } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, toFixed, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
export default {
  name: 'Freight',
  components: {
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      toFixed: toFixed,
      loading: false,
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTimes: [],
      searchFrom: {
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      total: 0,
      // 按钮
      btnFlg: [],
      detilsMark: false,
      yundanList: [],
      btnIdArr: ['01N00J0100'],
      tableList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yingFuSettlement')
    this.createTimes = getLastMonth()
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 150 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 撤回
    chehuiFN (row) {
      this.$confirm('是否执行撤销申请操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        removeRiskControlInfo({ riskControlId: row.riskControlId, wayIds: row.wayId.toString(), wayNumber: 1 }).then(res => {
          findWayBusinessList({
            riskControlId: row.riskControlId
          }).then(res => {
            this.loading = false
            this.yundanList = res
          })
          this.getList()
          this.$message({
            message: '撤销成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 点击风控号
    detilsFn (row) {
      this.loading = true
      findWayBusinessList({
        riskControlId: row.id
      }).then(res => {
        this.loading = false
        this.yundanList = res
        this.detilsMark = true
      })
    },
    getTimes () {
      if (this.createTimes) {
        this.$set(this.searchFrom, 'createTimeStart', this.createTimes[0])
        this.$set(this.searchFrom, 'createTimeEnd', this.createTimes[1])
      } else {
        this.$set(this.searchFrom, 'createTimeStart', '')
        this.$set(this.searchFrom, 'createTimeEnd', '')
      }
    },
    // 获取列表
    getList () {
      this.loading = true
      this.getTimes()
      findRiskControlInfoList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },

    // 选择数据
    selectGoods (selection) {

    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      // this.createTimes = []
      // this.createTimes = [startDatr, endDate]
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    }

  }
}
</script>
<style>
.el-table__body tr.warning-row > td {
  background-color: #f9bc04 !important;
}
</style>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}
.inpBox .el-date-editor{
  width: 420px!important;
}

</style>
